const GENERATION_SUCCESS = 'app/generation/GENERATION_SUCCESS'
const GENERATION_ERROR = 'app/generation/GENERATION_ERROR'

export {
  GENERATION_ERROR,
  GENERATION_SUCCESS
}
